import { Job } from '../data/jobs';
import { markdownToHtml } from '../services/markdownLoader';
import { X, MapPin, Briefcase, Calendar, DollarSign } from 'lucide-react';

interface JobDetailModalProps {
  job: Job;
  onClose: () => void;
}

export function JobDetailModal({ job, onClose }: JobDetailModalProps) {
  const tags = job.tags.split(',').map(tag => tag.trim());

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{job.title}</h1>
            <p className="text-xl text-blue-600 font-semibold">{job.company}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <X size={28} />
          </button>
        </div>

        {/* Metadata */}
        <div className="px-6 py-4 bg-gray-50 border-b border-gray-200 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Lugar</p>
            <p className="flex items-center gap-2 text-gray-900 font-medium">
              <MapPin size={16} className="text-gray-400" />
              {job.location}
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Tipo</p>
            <p className="flex items-center gap-2 text-gray-900 font-medium">
              <Briefcase size={16} className="text-gray-400" />
              {job.type}
            </p>
          </div>
          {/*
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Salary</p>
            <p className="flex items-center gap-2 text-gray-900 font-medium">
              <DollarSign size={16} className="text-gray-400" />
              {job.salary}
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Experience</p>
            <p className="flex items-center gap-2 text-gray-900 font-medium">
              <Calendar size={16} className="text-gray-400" />
              {job.experience}
            </p>
          </div>
           */}
        </div>

        {/* Tags */}
        {/*
        <div className="px-6 py-4 border-b border-gray-200">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Skills & Tags</p>
          <div className="flex flex-wrap gap-2">
            {tags.map((tag, idx) => (
              <span
                key={idx}
                className="inline-block text-sm bg-blue-50 text-blue-700 px-3 py-1 rounded-full font-medium"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
         */}
        {/* Content */}
        <div className="px-6 py-6">
          <div
            className="prose prose-sm max-w-none text-gray-700"
            dangerouslySetInnerHTML={{ __html: markdownToHtml(job.body) }}
          />
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-between items-center">
          <div className="text-sm text-gray-600">
            <p>Publicado: <span className="font-semibold">{job.posted}</span></p>
            <p>Hasta: <span className="font-semibold">{job.deadline}</span></p>
          </div>
          <button
            onClick={onClose}
            className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
